/* eslint-disable react/jsx-no-comment-textnodes */
/* eslint-disable max-len */
import React, { useState, useEffect } from 'react'
import Link from 'next/link'
import PropTypes from 'prop-types'
import LayoutSimple from '../../components/layoutsimple'
import MetaHeaders from '../../components/metaheaders'

import { FORESIGHT_CONTENTFUL_ID, PATHS } from '../../utils/vars'
import ContentfulClient from '../../contentful'

import closedNavImg from '../../assets/nfttemplate/x-white.svg'
import openNavImg from '../../assets/nfttemplate/ham-white.svg'
import styles from './Foresight.module.scss'

const Foresight = ({ metaDescription, metaTitle }) => {
    const [toggle, setToggle] = useState(false)

    const toggleImage = {
        backgroundImage: `url(${toggle ? closedNavImg : openNavImg})`,
    }

    useEffect(() => {
        setToggle(false)
    }, [])

    useEffect(() => {
        function onScroll() {
            const currentScrollPos = window.pageYOffset
            if (currentScrollPos > 1000) {
                document.getElementById('navbar').style.top = '-250px'
            } else {
                document.getElementById('navbar').style.top = '0'
            }
        }
        window.addEventListener('scroll', onScroll)

        return function unMount() {
            window.removeEventListener('scroll', onScroll)
        }
    })

    return (
        <>
            <MetaHeaders
                title={metaTitle}
                description={metaDescription}
            />
            <LayoutSimple>
                <div className={styles.foresight}>
                    <nav style={{ maxHeight: toggle ? '600px' : '0px' }} className={`${styles.navbar}`} id="navbar">
                        <Link href={PATHS.HOME} passHref>
                            <a href="/" className={styles.navbarBrand}>
                                project: metaverse [foresight]
                            </a>
                        </Link>
                        <button onClick={() => setToggle(!toggle)} type="button" className={`${styles.navbarToggle} ${styles.collapsed}`} aria-label="Toggle navigation">
                            <span style={toggleImage} className={styles.navbarToggleIcon} />
                        </button>
                        <div className={styles.navbarLinks}>
                            <div className={styles.pages} />
                            <div className={styles.externalSites}>
                                <a href={PATHS.HOME}>
                                    <div className={styles.navMargin}>
                                        <span className={styles.main}>
                                            sign-up
                                        </span>
                                    </div>
                                </a>
                                <a href={PATHS.HOME}>
                                    <div className={styles.navMargin}>
                                        <span className={styles.main}>
                                            urbancoolab
                                        </span>
                                    </div>
                                </a>
                                <a href={PATHS.HOME} disabled style={{ cursor: 'default' }}>
                                    <div className={styles.navMargin}>
                                        <span className={styles.main} style={{ color: 'grey', cursor: 'default' }}>
                                            x
                                        </span>
                                    </div>
                                </a>
                                <a href={PATHS.HOME} target="_blank" rel="noopener noreferrer">
                                    <div className={styles.navMargin}>
                                        <span className={styles.main}>
                                            the foresight studio
                                        </span>
                                    </div>
                                </a>
                            </div>
                        </div>
                    </nav>

                    <div className={styles.banner}>
                        <div className={styles.wrapper}>
                            <div className={styles.hero}>
                                <h1>Beyond Uncertainties. Explosive Discontinuities. Rethinking Humanities.</h1>
                                <p className={styles.bodyText}>an urbancoolab x the foresight studio project / the world&apos;s first foresight practice in the metaverse</p>
                                <p className={styles.divider}>////////////////////////////////////</p>
                            </div>

                            <div className={styles.story}>
                                <p className={styles.bodyText}>The disruptive power of Web3, the Crypto meltdown, the lingering of the pandemic, and deglobalization marked the end of an era -- the beginning of a new one. The comfort of the known, thinking all will be fine -- cannot be assumed for granted. Uncertainty made itself evident and tangible at different levels, triggering new issues, risks, challenges, and possibilities. Everyone sees only pieces of the picture, yet it is still unclear what is the pace of decentralization, how to move beyond this uncertainty, and how to be prepared for the next.</p>
                                <p className={styles.divider}>////////////////////////////////////</p>
                                <h2>Future Industry Giants Are In “Incubation”</h2>
                                <p className={styles.divider}>////////////////////////////////////</p>
                                <p className={styles.bodyText}>For nearly three decades, we have pioneered foresight methodologies.  With our foresight teams, we have meticulously researched weak signals and manifested them into macro forces of change. We have produced dynamic scenarios that result in the creative destruction of old industries and the creation of new ones. We&apos;ve  helped Fortune 500s to navigate and prosper from these disruptive forces. This project aims to help executives discover critical insights, shape business strategy, and initiate strategic action to take on the future, today.</p>

                                <p className={styles.bodyText}>
                                    To understand how Web3 will shape our futures: this Metaverse Foresight Report (to be published Sept 2022) provides future scenarios and identifies new opportunities for growth and potential collaborations in and adjacent to your business. We also highlight emerging or atypical
                                    threats across most industries and business models.

                                </p>
                                <p className={styles.divider}>////////////////////////////////////</p>
                            </div>

                            <div className={styles.story}>
                                <h2>The Reason Why The Biggest And Most Capitalized Companies Collapse</h2>
                                <p className={styles.divider}>////////////////////////////////////</p>
                                <p className={styles.bodyText}>Discontinuities are the unanticipated events that can suddenly shift the landscape in an industry or for a company, requiring an immediate response either to mitigate loss or to capture opportunity. Web3 is enabling these discontinuities; to do more than just react, organizations need to look much further and shape what&apos;s next. Instead of sleepwalking into a future and reading outdated trends, this project takes a human-first approach to innovation in a vast sea of technocratic ideologies, myopic shareholder-only thinking, and corporate inertia. Because the truth is, the best way to sustainably create new business and social value — as well as breakthrough products and experiences — is to focus on the humans.</p>
                                <p className={styles.divider}>////////////////////////////////////</p>
                            </div>

                            <div className={styles.story}>
                                <h2>Sign Up For A Free Weak Signals Set</h2>
                                <p className={styles.divider}>////////////////////////////////////</p>
                                <p className={styles.bodyText}>This Metaverse strategic foresight project was created by ex-Idea Couture CEO and co-founder Idris Mootee and the team from The Foresight Studio, after 2,000+ hours of scanning. It is considered the most comprehensive Web3 strategic foresight toolkit. It includes all the Weak Signals, Frameworks, Scenarios, and Tools required to conduct future-looking exercises within your organization or your clients. Most organizations may have a vision of their preferred future, they can refer to the many scenarios to define if their company is ready for the future.</p>
                                <div className={styles.splitScreen}>
                                    <div className={styles.screenLeft}>
                                        <h4 className={styles.marginRightOne}>Get:</h4>
                                        <ul>
                                            <li>Free Set of Weak Signals</li>
                                            <li>Sample Report</li>
                                            <li>Access to the Community</li>
                                        </ul>
                                    </div>
                                    <div className={styles.screenRight}>
                                        <h4 className={styles.marginRight}>pre-order with a supporter discount</h4>
                                        <ul>
                                            <li>get a 30% discount</li>
                                            <li>get a secret item for supporters</li>
                                            <li>early and exclusive access to the platform</li>
                                        </ul>
                                    </div>
                                </div>
                                <div className={styles.download}>
                                    <div className={styles.downloadLeft}>
                                        <a href="/">Free download</a>
                                        <p className={styles.downloadDivider}>////////////////////////////////////</p>
                                    </div>
                                    <div className={styles.downloadRight}>
                                        <a href="/">Pre-order Now</a>
                                        <p className={styles.downloadDivider}>////////////////////////////////////</p>
                                    </div>
                                </div>
                                <div className={styles.contact}>
                                    <p> got questions?</p>
                                    <h5>contact us at:</h5>
                                    <a href="mailto:human@urbancoolab.com?subject=Foresight">human@urbancoolab.com</a>
                                </div>
                            </div>
                        </div>
                        <div className={styles.footer}>
                            <p>the world&apos;s first foresight practice in the metaverse</p>
                            <p>© urbancoolab 2022</p>
                        </div>
                    </div>
                </div>
            </LayoutSimple>
        </>
    )
}

Foresight.propTypes = {
    metaTitle: PropTypes.string.isRequired,
    metaDescription: PropTypes.string.isRequired,
}

Foresight.getInitialProps = async () => {
    const res = await ContentfulClient.getEntry(FORESIGHT_CONTENTFUL_ID)
    return res.fields
}

export default Foresight
